﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function StandardsLauncher() {
    return (
        <div className="launcher-container">
            <h1 className="main-title">STANDARDS LAUNCHER</h1>

            <div className="card-container">
                <NavLink className="pw-card-link" to="/standardsmaintenance">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">fact_check</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">STANDARDS MAINTENANCE</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/usprefstandards">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">fact_check</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">USP STANDARDS</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/eprefstandards">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">fact_check</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">EP STANDARDS</div>
                        </div>
                    </div>
                </NavLink>

            </div>
        </div>
    );
}
